<template>
  <draggable
    class="dragArea"
    :data-display="display"
    :list="questionsMetadata.widgets"
    :move="checkMove"
    :draggable=false
    :component-data="getComponentData()"
    :group="{ name: 'question' }"
    :force-fallback="true"
    :scroll-sensitivity="200"
  >
    <div
      class="draggable"
      v-for="(question, i) in questionsMetadata.widgets"
      :key="question.name + i"
    >
      <v-card v-if="question.display === 'question'" style="margin-bottom: 10px;">
        <v-card-text>
          <div class="text--primary">
            <widget-component
              :widgetMetadata="question"
            />
            <widget-component
              style="margin-top: -3px;"
            />
            <v-card>
              <v-card-title class="text-overline"><h4>Answer</h4></v-card-title>
              <v-card-text>
                <widget-component
                  :widgetMetadata="question.preview"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="onClickRemove(question)">Remove</v-btn>
                <v-btn color="blue" text @click="onClickAdd(question)">Add</v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-card-text>
        <!-- original desing version <cards>  -->
        <!-- <v-tabs>
          <v-tab>Specimen Question</v-tab>
          <v-tab-item>
            <v-card>
              <v-card-text>
                <div class="text--primary">
                  <widget-component
                    :widgetMetadata="question"
                  />
                  <widget-component
                    style="margin-top: -10px;"
                  />
                  <v-card>
                    <v-card-title class="text-overline"><h4>Answer</h4></v-card-title>
                    <v-card-text>
                      <widget-component
                        :widgetMetadata="question.preview"
                      />
                    </v-card-text>
                  </v-card>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="onClickRemove(question)">Remove</v-btn>
                <v-btn color="blue" text @click="onClickAdd(question)">Add</v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs> -->
      </v-card>
    </div>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';
// import DisplayQuestionName from './DisplayQuestionName.vue';
import WidgetComponent from '../../../../components/ui/WidgetComponent.vue';
// import services from '../../../../services';

import FormService from '../../../../services/medical_registry/form.service';

export default {
  name: 'nested-question',
  components: {
    // DisplayQuestionName,
    WidgetComponent,
    draggable,
  },
  props: {
    display: String,
    questionsMetadata: {
      questionRawList: Array,
      questionList: Array,
      widgets: Array,
      parentWidget: [Array, Object],
    },
  },
  data: () => ({
    text: '',
    choices: [],
    testing: {},
    updateIndexTimer: '',
    widgetMetadata: {
      type: 'select',
      name: 'selectedQuestion',
      label: 'Question',
      placeholder: 'Enter question',
      multiple: false,
      rules: [
        (v) => !!v || 'Question is required',
      ],
      items: [
        {
          label: 'Short answer',
          code: 'shortAnswer',
          icon: 'mdi-text-short',
        },
        {
          label: 'Paragraph',
          code: 'paragraph',
          icon: 'mdi-text-long',
        },
        {
          label: 'Multiple choice',
          code: 'multipleChoice',
          icon: 'mdi-radiobox-marked',
        },
        {
          label: 'Checkboxes',
          code: 'checkboxes',
          icon: 'mdi-checkbox-marked',
        },
        {
          label: 'Dropdown',
          code: 'dropdown',
          icon: 'mdi-arrow-down-drop-circle',
        },
        {
          label: 'File upload',
          code: 'fileUpload',
          icon: 'mdi-cloud-upload',
        },
        {
          label: 'Date',
          code: 'date',
          icon: 'mdi-calendar',
        },
        {
          label: 'Time',
          code: 'time',
          icon: 'mdi-clock-outline',
        },
      ],
      value: '',
    },
  }),
  async created() {
    // this.widgetMetadata.items = await questionService.getList();
    // this.widgetMetadata.items = this.widgetMetadata.items.map((c) => {
    //   const { type, _id: code, name: label } = c;
    //   const icon = FormService.getQuestionTypeIcon(type);
    //   return {
    //     label,
    //     code,
    //     icon,
    //   };
    // });
  },
  watch: {
    // IMPORTANT!!!! -- READ IF YOU FORGET THE CODE
    // update widget parent every time the array changes
    // this is called many times depends on the groups you have in the widgets
    // it's called one time for everything and 2 times if you have 2 group widgets
    // eslint-disable-next-line object-shorthand
    // 'questionsMetadata.widgets'(newValue) {
    //   const goToWidgets = (widget, index, parent) => {
    //     const refWidget = widget;
    //     refWidget.index = index;
    //     refWidget.parent = parent;
    //     console.log('refWidget', refWidget);
    //   };

    //   newValue.forEach((widget, index) => {
    //     goToWidgets(widget, index, this.questionsMetadata.parentWidget);
    //   });
    // },
    // eslint-disable-next-line object-shorthand
    'questionsMetadata.widgets': {
      handler(newValue) {
        const goToWidgets = (widget, index, parent) => {
          const refWidget = widget;
          refWidget.index = index;
          refWidget.parent = parent;
        };

        if (Array.isArray(newValue)) {
          newValue.forEach((widget, index) => {
            goToWidgets(widget, index, this.questionsMetadata.parentWidget);
          });
        }
      },
      deep: true, // Ensures nested changes are tracked
      immediate: true, // Optional: immediately run this on component mount
    },
  },
  methods: {
    getQuestionParent(_question) {
      if (_question.parent?.display === 'section') {
        return _question.parent.widgets;
      }
      return _question.parent;
    },
    getWidgetQuestion({ question, index }) {
      const { parent, display } = question;
      if (display === 'question') {
        return this.widgetQuestion({
          questions: this.questionsMetadata.questionRawList,
          selections: this.questionsMetadata.questionList,
          parent,
          index,
        });
      } if (display === 'section') {
        return this.widgetQuestion({
          index,
          parent,
        });
      }
      throw new Error('Question type unsupported');
    },
    // update the index of then next child
    adjustQuestionIndices(index, qParent) {
      // eslint-disable-next-line no-plusplus
      for (let i = index; i < qParent.length; i++) {
        const nextWidget = qParent[i];
        if (nextWidget) {
          nextWidget.index = i;
        }
      }
    },
    onClickAdd(question) {
      const index = question.index + 1;
      const widget = this.getWidgetQuestion({
        question,
        index,
      });
      const qParent = this.getQuestionParent(question);
      qParent.splice(index, 0, widget);
      this.adjustQuestionIndices(index + 1, qParent);
    },
    onClickRemove(question) {
      const { index } = question;
      const qParent = this.getQuestionParent(question);
      qParent.splice(index, 1);
      this.adjustQuestionIndices(index, qParent);
    },
    onClickGroup(question) {
      const refQuestion = question;
      const { index } = refQuestion;
      const qParent = this.getQuestionParent(refQuestion);

      const sectionWidget = FormService.getWidgetSection({
        index,
        parent: qParent,
      });
      refQuestion.index = 0;
      refQuestion.parent = sectionWidget;
      sectionWidget.widgets.push(refQuestion);
      qParent.splice(index, 1);
      qParent.splice(index, 0, sectionWidget);
    },
    // not a reliable callback to update index of widgets
    handleChange() {
    },
    inputChanged(value) {
      this.activeNames = value;
    },
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged,
        },
        attrs: {
          wrap: true,
        },
        props: {
          value: this.activeNames,
        },
      };
    },
    checkMove(evt) {
      const { draggedContext } = evt;
      const { element } = draggedContext;
      const { display } = element;
      if (display === 'section') {
        const { relatedContext } = evt;
        const { component } = relatedContext;
        const { $attrs } = component;
        const dataTesting = $attrs['data-display'];
        if (dataTesting === 'display') {
          return false;
        }
      }
      return true;
    },
    widgetQuestion({
      questions, selections, parent, index,
    }) {
      const widget = {
        type: 'select',
        display: 'question',
        name: 'selectedQuestion',
        label: 'Question',
        placeholder: 'Enter question',
        parent,
        index,
        conditionalWidgets: {
          isRequired: {
            type: 'switch',
            name: 'isRequired',
            label: 'Mandatory',
            value: true,
          },
        },
        multiple: false,
        value: '',
        preview: {},
        items: selections,
        rules: [
          (v) => !!v || 'Question type is required',
        ],
      };
      // eslint-disable-next-line func-names
      widget.selectChange = function (code, oldValue) {
        if (code) {
          const question = questions.find((q) => {
            const { _id } = q;
            return _id === code;
          });
          this.preview = { ...FormService.getValidWidgetJSON(question), readonly: false };
        } else {
          this.preview = {};
        }
        this.selectChange(code, oldValue);
      };
      return widget;
    },
  },
};
</script>

<style scoped>
.dragArea {
  padding: 10px;
  min-height: 100px;
  /* outline: 1px dashed; */
}
</style>
